import { render, staticRenderFns } from "./Videoteque.vue?vue&type=template&id=66776747&scoped=true&"
import script from "./Videoteque.vue?vue&type=script&lang=js&"
export * from "./Videoteque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66776747",
  null
  
)

export default component.exports